import { ApplicationModel } from './application.model';
import { Model } from '@/app/shared/models/model';

export class ActivationOperationModel extends Model {
  public ActivatedAt!: Date;
  public UpdatedAt?: Date;
  public AccountId!: string;
  public Application!: ApplicationModel;
}
